import { createContext, useContext } from 'react';
import { useAuthState } from '@/hooks/useAuthState';

interface AuthContextType {
  user: any;
  session: any;
  teams: any[];
  currentTeamId: string | null;
  loading: boolean;
  error: string | null;
  signOut: () => Promise<void>;
  setCurrentTeamId: (teamId: string | null) => void;
  refetchTeams: () => Promise<void>;
  getUserRole: (teamId: string) => string | null;
  canAccessContactInfo: (teamId: string) => boolean;
  canEdit: (teamId: string) => boolean;
  canAnalyze: (teamId: string) => boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const authState = useAuthState();

  const value = {
    user: authState.user,
    session: authState.session,
    teams: authState.teams,
    currentTeamId: authState.currentTeamId,
    loading: authState.loading,
    error: authState.error,
    signOut: authState.signOut,
    setCurrentTeamId: authState.setCurrentTeamId,
    refetchTeams: authState.refetchTeams,
    getUserRole: authState.getUserRole,
    canAccessContactInfo: authState.canAccessContactInfo,
    canEdit: authState.canEdit,
    canAnalyze: authState.canAnalyze,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};